define('views/modules/login/login-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils', 'toastr',
    // services
    'services/session',
    'services/activity-watcher',
    'services/loading',
    'services/user',
    'services/i18n',
    'services/api',
    'services/platform.service',
    // models
    'models/member/login',
    // views
    'views/parts/form/textbox',
    'views/parts/form/button',
    // templates
    'text!templates/modules/login/login-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U, Toastr,
    // services
    Session,
    ActivityWatcher,
    Loading,
    User,
    i18n,
    API,
    PlatformService,
    // models
    MLogin,
    // views
    VTextbox,
    VButton,
    // templates
    TLoginForm
) {

    var VLoginForm = Backbone.View.extend({
        template: TLoginForm,

        events: {
            "submit .form": "onSubmit",
        },

        regions: {
            username: ".username-field",
            password: ".password-field",
            submit: ".submit-button",
        },

        initialize: function(options) {
            this.options = _.extend({
                // TODO: handle forgot password inside this application instead
                forgot_password_url: window.env.OLD_ORIGIN + "public/password_recover.php",
                create_user_url: window.env.OLD_ORIGIN + "public/register_password.php"
            }, options);

            var model = this.model = new MLogin();
            // namespace views inside an object.
            this.view = {
                username: VTextbox.create("Username", model, "username", "email", { htmlAfter: "<span class='sl-icon-user form-control-feedback'></span>" }),
                password: VTextbox.create("Password", model, "password", "password", { htmlAfter: "<span class='sl-icon-lock form-control-feedback'></span>" }),
                submit: VButton.create("Login", "submit", this.onSubmit, this, { icon: 'sl-icon-key' }),
            };

            this.bNeedUpdate = false;
            this.attrs = null;
        },

        render: function() {

            // Render Template HTML with Mustache
            var html = Mustache.render(this.template, Mustache.getContext(_.extend(this.options, { appVersion: 'v' + env.APP_VERSION })));
            this.$el.empty().append(html); // this is a little more optimised than 'html()'

            // caching scoped jquery element from 'regions'.
            this.generateZones();
            var view = this.view,
                zone = this.zone;
            this.assign(view.username, zone.$username)
                .assign(view.password, zone.$password)
                .assign(view.submit, zone.$submit);

            return this;
        },

        setPristine: function() {
            this.model.reset();
        },

        ////////////
        // events //
        ////////////
        onSubmit: function(e) {
            e.preventDefault();
            var model = this.model;

            if (model.isValid(true)) {

                Session.signIn(
                    model.getUser(),
                    model.getPass(), {
                        context: this,
                        success: function() {
                                Loading.toggle(true);
                                this.setPristine();

                                this.when(User.fetch()).then(function() {
                                    //Check for the required fields
                                    if (_.isEmpty(User.get("units").distance) || _.isEmpty(User.get("units").length) || _.isEmpty(User.get("units").weight) || _.isEmpty(User.get("timezone")) || _.isEmpty(User.get("country")) || _.isEmpty(User.get("province")) || _.isEmpty(User.get("language"))) {
                                        this.checkIfRequiredFieldsExistsInClientsProfiles();
                                    }
                                    //isActive() === false mean Pending === true
                                    if (!User.isActive()) {
                                        this.getClientHash().then(function(response) {
                                            var activationUrl = Mustache.render("public/login.php?id={{{client_id}}}&hash={{{hash}}}", {
                                                 hash: response,
                                                 client_id: User.get("_id"),
                                             });
                                            var activationUrl =  window.env.OLD_ORIGIN + activationUrl;
                                            Session.onUnauthorized();
                                            this.redirectToActivationPage(activationUrl);
                                        });
                                    } else {
                                        i18n.setLanguage(User.get('language').replace('_', '-'))
                                        User.setSelectedUser(null);
                                        ActivityWatcher.start();
                                        if (User.getMainGroup().isSupervisor) {
                                            Backbone.history.redirect("#/supervisor");
                                        } else {
                                            Backbone.history.redirect("#/");
                                        }
                                    }
                                });
                        },
                        error: function(response) {
                            if (response && response.responseJSON && response.status !== 406) {
                                var toastTitle = i18n.t(response.responseJSON.code, { ns: "api-messages" }),
                                    toastText = i18n.t(response.responseJSON.code + "_MESSAGE", { ns: "api-messages" });

                                this.showError(toastTitle, toastText);
                            } else {
                                U.error("Something went wrong during the login. Make sur you have the good username and password combination.");
                            }
                        }
                    });
            } else {
                var context = this;

                // Hard-testing toastr notifications. THIS CODE MUST BE OPTIMIZED!!!
                _.each(model.validationError, function(value, key) {
                    var toastTitle = i18n.t(model.validationError[key][0]),
                        toastText;
                    // Custom error text depending on the field (should come from the model).
                    if (key === 'username') {
                        toastText = '<a href="#">' + i18n.t("login_empty_username_message") + '</a>';
                    } else if (key === 'password') {
                        toastText = '<a href="#" onclick="window.open(\'' + context.options.forgot_password_url + '\', \'_system\'); return false;">' + i18n.t("login_empty_password_message") + '</a>';
                    } else {
                        toastText = '';
                    }

                    context.showError(toastTitle, toastText);
                });

                U.warn(model.validationError);
            }
        },

        getClientHash: function() {
            var requestParam = Mustache.render("?username={{{username}}}&client_id={{{client_id}}}", {
                    username: encodeURIComponent(User.get('email')),
                    client_id: "testclientid",
                });
            var clientHash = "";

            return Backbone.ajax(
                _.extend({
                    url: API.url("oauth2/oldtoken") + requestParam,
                    method: "GET",
                    async: false,
                    context: this,
                }
            ));
        },

        redirectToActivationPage: function(activationUrl) {
            if (PlatformService.isNative()) {
                window.open(activationUrl, '_system');
            } else {
                // Workaround to ensure that redirections will work on safari + chrome
                U.delayRedirect(activationUrl);
            }
        },

        checkIfRequiredFieldsExistsInClientsProfiles: function() {
          var units = User.get("units");
          var geoObj;

          geoObj = this.getGeolocalizationInfos(User.get("country"), User.get("province"), User.get("timezone"));

          this.setUnitEmptyField(units, geoObj);

          if (_.isEmpty(User.get("timezone")) && !_.isEmpty(geoObj.time_zone)) {
            this.bNeedUpdate = true;
            User.set("timezone", geoObj.time_zone, { silent: true });
            this.attrs.timezone = geoObj.time_zone;
          }
          if (_.isEmpty(User.get("country")) && !_.isEmpty(geoObj.country_code)) {
            this.bNeedUpdate = true;
            User.set("country", geoObj.country_code, { silent: true });
            this.attrs.country = geoObj.country_code;
          }
          if (_.isEmpty(User.get("province")) && User.get("country") === 'CA' && !_.isEmpty(geoObj.province_code)) {
            this.bNeedUpdate = true;
            User.set("province", geoObj.province_code, { silent: true });
            this.attrs.province = geoObj.province_code;
          }

          this.saveUser(this.attrs);

        },

        saveUser: function(attr) {
          if (this.bNeedUpdate === true) {
             User.save(attr, _.extend({
                     patch: true,
                     context: this,
                     validate: false,
                 }, null));
          }
        },

        setUnitEmptyField: function(units, geoObj) {
          if (_.isEmpty(units.distance) && !_.isEmpty(geoObj.distance_Unit)) {
            this.bNeedUpdate = true;
            User.set("distanceUnit", geoObj.distance_Unit, { silent: true });
          }
          if (_.isEmpty(units.length) && !_.isEmpty(geoObj.length_Unit)) {
            this.bNeedUpdate = true;
            User.set("lengthUnit", geoObj.length_Unit, { silent: true });
          }
          if (_.isEmpty(units.weight) && !_.isEmpty(geoObj.weight_Unit)) {
            this.bNeedUpdate = true;
            User.set("weightUnit", geoObj.weight_Unit, { silent: true });
          }
          this.attrs = User.changedAttributes();
        },

        getGeolocalizationInfos: function(country, province_code, time_zone) {
          var geoObj = { 'country_code': country,
                        'province_code': province_code,
                        'time_zone': time_zone,
                        'distance_Unit': 'km',
                        'weight_Unit': 'kg',
                        'length_Unit': 'cm'
                      };

          try {
            if (_.isEmpty(geoObj.country) || _.isEmpty(geoObj.province_code) || _.isEmpty(geoObj.time_zone)) {
              var xmlHttp = new XMLHttpRequest();
              xmlHttp.open("GET", 'https://freegeoip.net/json/', false); // false for synchronous request
              xmlHttp.send(null);
              var obj = JSON.parse(xmlHttp.responseText);
              if (obj.hasOwnProperty('country_code') && obj.hasOwnProperty('region_code') && obj.hasOwnProperty('time_zone')) {
                  geoObj.country_code = obj.country_code.toUpperCase();

                  if (geoObj.country_code === 'CA')
                      geoObj.province_code = obj.region_code.toUpperCase();

                  geoObj.time_zone = obj.time_zone;
                }
            }
            //The 3 country that didn't use the metric system - USA, Myanmar(Burma), Liberia
            var metricExcludeCountryList = ['US', 'MM', 'LR'];
            if (metricExcludeCountryList.indexOf(geoObj.country_code) !== -1) {
              geoObj.distance_Unit = 'mi';
              geoObj.weight_Unit = 'lbs';
              geoObj.length_Unit = 'in';
            } else {
              geoObj.distance_Unit = 'km';
              geoObj.weight_Unit = 'kg';
              geoObj.length_Unit = 'cm';
            }
            return geoObj;
          } catch (err) {
            return geoObj; //Even if an error occur, we return the default metric system units
          }
        },

        showError: function(title, message) {
            // Display error message using toast (should use a global function to handle notifications).
            // https://github.com/CodeSeven/toastr
            Toastr.error(
                message,
                title, { // These options should be set globally.
                    positionClass: "toast-top-center", // Default = toast-top-right
                    newestOnTop: false, // Default = true
                    showMethod: "slideDown",    // Default = fadeIn
                    tapToDismiss: false,  // Default = false
                    closeButton: true
                }
            );
        }
    });

    return VLoginForm;

});

